<template>
  <v-card>
    <v-card-text>
      <v-btn v-if="order.status=='paid'" @click.stop="confirm()">Confirmer la commande</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      require: true
    }
  },
  methods: {
    confirm() {
      this.$store.dispatch("order/confirm", this.order.id).then(() => {
        this.$emit("update");
      });
    }
  }
};
</script>

<style>
</style>